<div mat-dialog-content>
  <p>Name:!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  </p>
  <p>City:
  </p>
</div>
<button  (click)="onCancelUserDialog()"></button>

<div mat-dialog-actions>
</div>
